import type { CatalogItem } from '~/models/common'

export const gameStages: CatalogItem[] = [
  {
    label: 'Alpha',
    value: 1,
  },
  {
    label: 'Beta',
    value: 2,
  },
  {
    label: 'Concept/Prototype',
    value: 3,
  },
  {
    label: 'Early Access/Soft launch',
    value: 4,
  },
  {
    label: 'Pre-Production',
    value: 7,
  },
  {
    label: 'Released',
    value: 5,
  },
  {
    label: 'Vertical slice',
    value: 6,
  },
]
